import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';

export interface CancelMeetingRequestParams {
	readonly id: string;
}

@Injectable({ providedIn: 'root' })
export class CancelMeetingRequestApiMutation extends ApiMutation<
	void,
	CancelMeetingRequestParams
> {
	client = 'messaging';
	document = gql`
		mutation CancelMeetingRequest($id: UUID!) {
			cancelMeetingRequest(id: $id)
		}
	`;
	method = 'cancelMeetingRequest';
}
